import {randomArray} from '@coolcolduk/util';

/**
 * Map parsed question data to form data format
 */
export function mapParsedQuestionToFormData(question: {
  questionText: string;
  hint?: string;
  incorrectAnswers?: string[];
  correctAnswer: string;
  explanation: string;
}): {
  questionText: string;
  hint?: string;
  options: string[];
  answer: string;
  explanation: string;
} {
  // Combine correct answer with incorrect answers
  const incorrectAnswers = question.incorrectAnswers || [];
  const allAnswers = [question.correctAnswer, ...incorrectAnswers].filter((a) => a && a.trim());

  // Remove duplicates and ensure correct answer is included
  const uniqueAnswers = Array.from(new Set(allAnswers));
  if (!uniqueAnswers.includes(question.correctAnswer)) {
    uniqueAnswers.unshift(question.correctAnswer);
  }

  // Shuffle the options (similar to how it's done in mapQuestionFromGeneratedQuestion)
  const options = randomArray(uniqueAnswers);

  // Ensure we have at least 2 options, pad with empty strings if needed
  while (options.length < 4) {
    options.push('');
  }

  return {
    questionText: question.questionText || '',
    hint: question.hint,
    options,
    answer: question.correctAnswer || '',
    explanation: question.explanation || '',
  };
}
